<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent mb-4">
        <div>
          <h3 class="mb-0">
            {{ $t("message.mobile.title") }}
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-xl-4">
          <router-link :to="{ name: 'metriques' }">
            <stats-card
              title="Metriques"
              type="gradient-teal"
              icon="fas fa-users-cog"
              class="mb-4"
            ></stats-card>
          </router-link>
        </div>
        <div class="col-lg-4 col-xl-4">
          <router-link :to="{ name: 'prestataires' }">
            <stats-card
              :title="$tc('message.mobile.prestataire', 2)"
              type="gradient-teal"
              icon="fas fa-users-cog"
              class="mb-4"
            ></stats-card>
          </router-link>
        </div>
        <div class="col-lg-4 col-xl-4">
          <router-link :to="{ name: 'etablissements' }">
            <stats-card
              :title="$tc('message.mobile.etablissement', 2)"
              type="gradient-teal"
              icon="fas fa-users-cog"
              class="mb-4"
            ></stats-card>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "UserManagement",
  computed: {
    ...mapGetters([
      "hasAdminRole",
      "hasMedecinControleRole",
      "hasPatientRole",
      "hasPraticienRole",
      "hasSouscripteurRole",
      "hasGestionnaireRole",
      "hasAssistante",
    ]),

    can: function () {
      return this.hasAdminRole || this.hasGestionnaireRole;
    },

    userIsMed: function () {
      return JSON.parse(localStorage.getItem("user"))["isMedicasure"];
    },
  },
};
</script>

<style scoped></style>
